/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { updateUrlWithStep } from './use-wizard-navigation-url';
import { handleInvalidStep } from './use-wizard-navigation-step-helpers';

/**
 * Notifies step change handler.
 * 
 * @param {Function | undefined} onStepChange - Step change callback
 * @param {string} stepId - Step ID
 * @returns {void}
 */
export function notifyStepChange(onStepChange: ((stepId: string) => void) | undefined, stepId: string): void {
  if (onStepChange) {
    onStepChange(stepId);
  }
}

/**
 * Validates and navigates to step.
 * 
 * @param {string} stepId - Step ID to navigate to
 * @param {Function} isValidStep - Step validation function
 * @param {string[]} stepIdOrder - Step order array
 * @param {Function} setSearchParams - Search params setter
 * @param {string} stepParamName - Step parameter name
 * @param {Function | undefined} onStepChange - Step change callback
 * @returns {void}
 */
export function validateAndNavigateToStep(
  stepId: string,
  isValidStep: (stepId: string) => boolean,
  stepIdOrder: string[],
  setSearchParams: (updater: (prev: URLSearchParams) => URLSearchParams, options?: { replace?: boolean }) => void,
  stepParamName: string,
  onStepChange: ((stepId: string) => void) | undefined
): void {
  if (!isValidStep(stepId)) {
    handleInvalidStep(stepId, stepIdOrder);
    return;
  }

  updateUrlWithStep(setSearchParams, stepParamName, stepId, false);
  notifyStepChange(onStepChange, stepId);
}
